import React from "react";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import { StyledWrapper } from "components/event/UpcomingWeekendEvent";
import SingleEvent from "components/event/SingleEvent";
import LoadingSpinner from "components/LoadingSpinner";
import HiddenOn from "components/common/HiddenOn";
import get from "lodash/get";

const NextEvent = ({ error, event, loading }) => {
  //if there is no event, hide (this will likely never happen)
  if (!event) {
    return null;
  }

  const { event_date, event_owner, event_repo, event_title, event_id } = event;

  return (
    <StyledWrapper>
      <div>
        <Typography variant="h5" component="h3">
          Next Event
        </Typography>
        <HiddenOn hideOn={!loading}>
          <LoadingSpinner />
        </HiddenOn>
        <HiddenOn
          hideOn={error}
          fallback={"There was a problem, please try again later"}
        >
          <SingleEvent
            event_id={event_id}
            event_date={event_date}
            event_owner={event_owner}
            event_repo={event_repo}
            event_title={event_title}
          />
        </HiddenOn>
      </div>
    </StyledWrapper>
  );
};

const mapStateToProps = (state) => ({
  event: get(state, "rootReducer.orbat.openEvents.events[0]", []),
  error: get(state, "rootReducer.orbat.openEvents.error"),
  loading: get(state, "rootReducer.orbat.openEvents.loading"),
});

export default connect(mapStateToProps, null)(NextEvent);
